import React from "react";
import { useNavigate } from "react-router-dom";
import logoImage from "./assets/GX Transparent logo.png";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast, ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import bgImg from "./assets/candiateImg.png";


//http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000
const SignInWithCandidate = ({ userId, setUserId }) => {
const navigate = useNavigate();

  const schema = yup.object().shape({
  email: yup
    .string()
    .required('Email is required')
    .email('Email must be valid')
    .transform(value => value.toLowerCase()), // Convert to lowercase
    
  password: yup
      .string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmit = async (data) => {
    try {
      const response = await fetch(
        "  http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/SignInCandidateAccount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const responseData = await response.json();
      console.log("Response data:", responseData);

      if (response.ok) {
        toast.success("SignIn Successfully", {
          position: "top-center",
          transition: Slide,
        });
        const token = responseData.token;
        localStorage.setItem("token", token);
        setUserId(responseData?.user?.id);
        reset();

        // Redirect after a delay
        setTimeout(() => {
          navigate("/EnteryCandidatePortel");
        }); // 2 seconds delay
      } else {
        toast.error(
          responseData.error ||
            "Failed to sign in. Please check your email and password."
        );
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to sign in. Please try again later.");
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `url(${bgImg})`,
      }}
    >
      <img
        src={logoImage}
        alt="Logo"
        className="absolute top-1 left-36 w-52 h-32"
      />
      <div className=" absolute items-start justify-start mb-52 left-32">
      <h2 className="text-2xl font-bold text-center text-primary-dark mb-28">
          ONBOARDING PORTAL
        </h2>
      </div>
      <div className=" left-4 absolute items-start justify-start bg-opacity-0 p-8 rounded-xl max-w-md w-full ml-8 mt-24">
        {" "}      
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label className="block text-neutral-dark mb-2 font-medium">
              Email
            </label>
            <input
              type="email"
              id="email"
              {...register("email")}
              className="w-full px-2 py-2 border-2 border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
            {errors.email && (
              <p className="text-red-500 text-sm">{errors.email.message}</p>
            )}
          </div>
          <div className="mb-6">
            <label className="block text-neutral-dark mb-2 font-medium">
              Password
            </label>
            <input
              type="password"
              id="password"
              {...register("password")}
              className="w-full px-2 py-2 border-2 border-neutral-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              required
            />
            {errors.password && (
              <p className="text-red-500 text-sm">{errors.password.message}</p>
            )}
          </div>
          <button
            type="submit"
            className="w-full bg-primary text-white py-2 rounded-lg hover:bg-primary-dark transition duration-300 mt-16"
          >
            Sign In
          </button>
        </form>
        <ToastContainer />
      </div>
    </div>
  );
};

export default SignInWithCandidate;
